import React, { useCallback, useContext } from 'react';
import { useDropzone } from 'react-dropzone';

import { SignedUrlRequest, ProcessScriptRequest } from '../generated/v1alpha1/script_processing_pb';
import { getSignedUrl, processScript } from '../clients/grpc';
import { AuthContext } from '../contexts/AuthContext';

import axios from 'axios';

const FileUpload: React.FC = () => {
  const { accessToken } = useContext(AuthContext);
  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    for (const file of acceptedFiles) {
      const signedUrlRequest: SignedUrlRequest = new SignedUrlRequest();
      signedUrlRequest.setObjectName(file.name);
      // TODO: Make the title consistent format with filename or think about this more
      signedUrlRequest.setContentType(file.type);
      signedUrlRequest.setMethod(SignedUrlRequest.MethodType.METHOD_PUT)
      // {
      //   objectName: file.name,
      //   method: SignedUrlRequest.MethodType.PUT,
      //   contentType: file.type,
      // };

      
      try {
        console.log('TRYING TO get signed url in env', process.env.REACT_APP_GRPC_ENDPOINT)
        const signedUrlResponse = await getSignedUrl(signedUrlRequest);
        const signedUrl = signedUrlResponse.getSignedUrl();

        console.log('TRYING TO UPLOAD')
        console.log(`Trying to upload file to GCS url ${signedUrl}`);
        await uploadFileToGCS(signedUrl, file);
        
        console.log('TRYING TO process script');
        const processScriptRequest = new ProcessScriptRequest();
        const uri = `gs://ddescript_screenplays_dev/uploaded/${file.name}`;
        processScriptRequest.setScriptPdfUri(uri);

        const response = await processScript(processScriptRequest);
        console.log('Script processed successfully:', response.toObject());
        alert(`File ${file.name} uploaded and processed successfully!`);

      } catch (error: any) {
        console.error('Error uploading file:', error);
        const errorMessage = error.message || error;
        alert(`Failed to upload file ${file.name}, error: ${errorMessage}`);
      }
      // try {
      //   const { signedUrl } = await getSignedUrl(signedUrlRequest);
      //   await uploadFileToGCS(signedUrl, file);
      //   alert(`File ${file.name} uploaded successfully!`);
      // } catch (error) {
      //   console.error('Error uploading file:', error);
      //   alert(`Failed to upload file ${file.name}`);
      // }
    }
  }, []);

  // Why is this not using client.UploadFile instead of axios? What's the benefit of axios?
  const uploadFileToGCS = async (url: string, file: File) => {
    await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const dropzoneStyle = isDragActive ? {...styles.dropzone, ...styles.dropzoneActive} : styles.dropzone;

  return (
    <div {...getRootProps()} style={dropzoneStyle}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p style={styles.dropzoneText}>Drop the files here ...</p>
      ) : (
        <p style={styles.dropzoneText}>Drag & drop your script PDF here, or click to select file</p>
      )}
    </div>
  );
};

const styles = {
  dropzone: {
    /** force same width in both states */
    width: '100%',
    minWidth: 0,            // important inside flex to prevent content-based sizing
    display: 'block',       // ensures block sizing even as a flex item
    flex: '1 1 0%',         // (optional) stretch in flex layouts

    border: '2px dashed #d1d5db',
    borderRadius: '12px',
    padding: 'clamp(40px, 10vw, 160px) clamp(20px, 5vw, 40px)',
    textAlign: 'center' as const,
    cursor: 'pointer',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    backgroundColor: '#ffffff',
  },

  /** only override what changes — don’t restate padding/radius */
  dropzoneActive: {
    borderColor: '#4a5568',   // keep dashed to avoid any border-style quirks
    backgroundColor: '#2d3748',
  },

  dropzoneText: {
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    color: '#4b5563',
    margin: 0,
  },
  dropzoneTextActive: {
    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
    color: '#f9fafb', // readable on dark bg
    margin: 0,
  },
}; 

export default FileUpload;
